import { render, staticRenderFns } from "./BetType.vue?vue&type=template&id=22b3d752&"
import script from "./BetType.vue?vue&type=script&lang=js&"
export * from "./BetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports